import { createFileRoute } from "@tanstack/react-router"
import UserAuditPage from "@/components/coreAnalytics/userAudit/UserAuditPage"

export const Route = createFileRoute("/core/analytics/user-audit")({ component: UserAuditPage })
